import { fetchTimeSlots } from '../actions/fetchTimeSlots';
import { serviceRequestType } from '@/context/serviceRequestContext';
import { bookSlot } from '@/labels/serviceRequest';
import { convertTimeStamp } from '@/components/Service/SubPages/MyDevices/utils';
import { Slot } from '@/types/slot';
import { reqHistoryType } from '@/types/reqHistory';
import { capitalize } from './string';
import date from './date';

export const computeDates = (startDate: Date, days: number) => {
  const dates = [startDate];
  for (let i = 1; i < days; i++) {
    let date = new Date(startDate);
    date.setDate(startDate.getDate() + i);
    dates.push(date);
  }
  return dates;
};

export const fetchTimeSlotsByDate = async (
  serviceType: serviceRequestType,
  serviceDate: Date,
  hubCode: string,
  selectedProduct: any,
  profileState: any,
  assetId?: string,
  workOrderId?: string,
) => {
  return await fetchTimeSlots(
    serviceType,
    serviceDate?.toISOString(),
    hubCode,
    selectedProduct,
    profileState,
    assetId,
    workOrderId,
  );
};

export const transformSlots = (slots: Slot[]) => {
  return slots.map((serviceSlot) => ({
    ...serviceSlot,
    slot: {
      startTime: serviceSlot.slot.startTime ? new Date(serviceSlot.slot.startTime) : null,
      endTime: serviceSlot.slot.endTime ? new Date(serviceSlot.slot.endTime) : null,
    },
  }));
};

export const transformAvailableSlots = (slots: Slot[]) => {
  return slots.map((serviceSlot) => ({
    ...serviceSlot,
    slot: {
      startTime: new Date(serviceSlot.slot.startTime),
      endTime: new Date(serviceSlot.slot.endTime),
    },
  }));
};

export const formatTo12Hrs = (datetime: Date, withTrailingZeros: boolean = false) => {
  let hours = datetime.getHours();
  let minutes = datetime.getMinutes();
  let meridiem = hours < 12 ? 'AM' : 'PM';
  let timeString = '';

  hours = hours % 12 || 12;

  timeString += hours;
  if (withTrailingZeros) {
    if (minutes >= 0) {
      timeString += ':' + minutes.toString().padStart(2, '0');
    }
  } else {
    if (minutes > 0) {
      timeString += ':' + minutes.toString().padStart(2, '0');
    }
  }

  timeString += ':00 ' + meridiem;

  return timeString;
};

export const formatedServiceDate = (date: Date) => {
  return (
    capitalize(bookSlot.days[date.getDay()]) +
    ', ' +
    date.getDate() +
    ' ' +
    bookSlot.months[date.getMonth()] +
    ' ' +
    date.getFullYear()
  );
};

export const formatedServiceSlot = (startTime: Date, endTime: Date) => {
  return (
    date.formatTime(startTime, {
      hour: '2-digit',
      minute: '2-digit',
    }) +
    ' to ' +
    date.formatTime(endTime, {
      hour: '2-digit',
      minute: '2-digit',
    })
  );
};

export const addDays = (date: Date, days: number) => {
  const _date = new Date(date);
  _date.setDate(_date.getDate() + days);
  return _date;
};

export const returnDates = () => {
  const _currDate = new Date();
  const _endDate = addDays(_currDate, 180);
  return { currentDate: _currDate, endDate: _endDate };
};

export const transformServiceHistory = (data: reqHistoryType) => {
  const { openRequests, closedRequests } = data;
  return {
    openRequests: openRequests.map((el) => {
      return {
        ...el,
        serviceDate: convertTimeStamp(el.slotData.slot.startTime, true),
        slotData: transformSlots([el.slotData])?.[0],
      };
    }),
    closedRequests: closedRequests.map((el) => {
      return {
        ...el,
        serviceDate: convertTimeStamp(el.slotData.slot.startTime, true),
        slotData: transformSlots([el.slotData])?.[0],
      };
    }),
  };
};

export const checkIfPastReq = (date: Date) => {
  return date ? new Date(date?.toDateString()) <= new Date(new Date().toDateString()) : true;
};

export const capitalizeFirstLetter = (sentence: string) => {
  const words = sentence.split(' ');

  const capitalizedWords = words.map((word) => {
    if (word.length > 0) {
      return word[0].toUpperCase() + word.slice(1);
    }
    return word;
  });

  const capitalizedSentence = capitalizedWords.join(' ');

  return capitalizedSentence;
};

export const serviceTypeDisplayValue = (serviceType: string) => {
  switch (serviceType?.toLocaleLowerCase()) {
    case 'repair':
      return 'Repair';
    case 'uninstall':
    case 'dismantling':
      return 'Uninstall';
    case 'reinstall':
    case 're_install':
    case 're-install':
      return 'Re-install';
    case 'new_install':
      return 'New Installation';
    case 'cr':
      return 'Consumable Replacement';
  }
};

export const checkTypeReinstall = (serviceType: string) =>
  serviceType?.toLowerCase() === 're_install' ||
  serviceType?.toLowerCase() === 'reinstall' ||
  serviceType?.toLowerCase() === 're-install';
